import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = configuredBackendUrl || (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** @deprecated Use fetchFileBlob() instead — avoids token in URL query string */
export const fileUrl = (storagePath) => {
  const token = localStorage.getItem("token");
  return `${API}/files/${storagePath}?auth=${token}`;
};

/**
 * Fetch a file securely using Authorization header (not query string).
 * Returns a blob URL suitable for img src, iframe, or download.
 */
export async function fetchFileBlob(storagePath) {
  const response = await api.get(`/files/${storagePath}`, { responseType: "blob" });
  return URL.createObjectURL(response.data);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
